'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html>
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#020617', color: '#f8fafc' }}>
        <main style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '1rem' }}>
        <div style={{ width: 'min(100%, 30rem)', boxSizing: 'border-box', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '1.5rem', background: 'rgba(15,23,42,0.94)', padding: '2rem', textAlign: 'center' }}>
          <p style={{ color: '#fda4af', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', margin: 0 }}>Recovery</p>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#fff', margin: '0.6rem 0 0' }}>Something went wrong</h1>
          <p style={{ color: '#cbd5e1', fontSize: '0.875rem', lineHeight: 1.5, margin: '0.85rem 0 0' }}>
            A critical error occurred. Try refreshing the page.
          </p>
          {error.digest && (
            <p style={{ color: '#475569', fontSize: '0.75rem', fontFamily: 'monospace', margin: 0 }}>
              Error ID: {error.digest}
            </p>
          )}
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center', marginTop: '1.5rem' }}>
            <button
              onClick={reset}
              style={{ minHeight: '48px', padding: '0.625rem 1.5rem', background: '#b91c1c', color: '#fff', border: 'none', borderRadius: '0.75rem', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer' }}
            >
              Try again
            </button>
            <a
              href="/"
              style={{ minHeight: '48px', boxSizing: 'border-box', display: 'inline-flex', alignItems: 'center', padding: '0.625rem 1.5rem', background: '#1e293b', color: '#f1f5f9', borderRadius: '0.75rem', fontSize: '0.875rem', fontWeight: 600, textDecoration: 'none' }}
            >
              Go home
            </a>
          </div>
        </div>
        </main>
      </body>
    </html>
  );
}
